var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_889_2840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8856 13.2189L26.7622 4.09556C26.0633 3.39667 25.1 3 24.0989 3H6.77778C4.7 3 3 4.7 3 6.77778V33.2222C3 35.3 4.7 37 6.77778 37H33.2222C35.3 37 37 35.3 37 33.2222V15.9011C37 14.9 36.6033 13.9367 35.8856 13.2189ZM10.5556 10.5556H23.7778V14.3333H10.5556V10.5556ZM29.4444 29.4444H10.5556V25.6667H29.4444V29.4444ZM29.4444 21.8889H10.5556V18.1111H29.4444V21.8889Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_889_2840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardback);
export default __webpack_public_path__ + "static/media/cardback.6ceb161d71c2ac0ebbdc57b508e5c697.svg";
export { ForwardRef as ReactComponent };